var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":5}},[_c('div',{staticClass:"conversion"},[_c('div',{staticClass:"head"},[_c('span',[_vm._v("提高会员转换")]),_c('img',{attrs:{"src":require("../../assets/images/home/more.png"),"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }